<template>
  <layout-component>
    <div class="banner banner-blog">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-8">
            <h1 class="left-bullet">{{'title-banner'|t}}</h1>
          </div>
          </div>


      </div>
    </div>
    <div class="container">
        <div class="row">
          <div v-for="post in blogposts" class="col-md-6" :key="post.id">
            <div class="card-blog">
              <router-link :to="'/blog/post/'+post.id">
              <div class="img-wrapper">
                <div class="noise">
                  <img class="img-fluid"  v-if="post.image" :src="'/storage/'+post.image" loading="lazy" />
                </div>
              </div>
              <div class="text-wrapper">
                <div class="date bottom-cut">{{ post.date | formatDateBlog }}</div>
                <h3>{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h3>
                <p class="btn-link">{{'card-btn'|t}}</p>
              </div>
              </router-link>
            </div>
          </div>
        </div>
    </div>
  </layout-component>
</template>

<script>
    export default {
      data() {
        return {
            blogposts:null,
        }
      },
      methods: {
        setData(data) {
          this.blogposts = data
        }
      },
      beforeRouteEnter(to, from, next) {
        Vue.axios.get('/blog').then( ({data}) => {
          next(vm => vm.setData(data))
        });
      }
    }
</script>

<i18n>
    {
      "en": {
        "title-banner": "What’s on ?",
        "card-btn": "Check it"
      },
      "fr": {
        "title-banner": "Quoi de neuf ?",
        "card-btn": "Voir"
      }
    }

</i18n>
